import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { MapPin, ArrowRight } from "lucide-react";
import { CITIES } from "../data/cities";
import { useLang } from "../i18n/LanguageContext";

const CitiesGrid = () => {
  const { t, lang } = useLang();

  return (
    <section id="cities" data-testid="cities-section" className="relative py-20 sm:py-28 bg-brand-cream">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="max-w-3xl mb-12"
        >
          <div className="inline-flex items-center gap-2 mb-5">
            <span className="h-px w-8 bg-brand-red" />
            <span className="text-xs font-bold uppercase tracking-[0.22em] text-brand-red">
              {t.cities.eyebrow}
            </span>
          </div>
          <h2 className="font-heading font-black text-3xl sm:text-4xl lg:text-5xl tracking-[-0.02em] text-brand-navy leading-[1.05]">
            {t.cities.title}
          </h2>
          <p className="mt-4 text-base text-brand-navy/75 max-w-xl">{t.cities.sub}</p>
        </motion.div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4">
          {CITIES.map((city, i) => (
            <motion.div
              key={city.slug}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.1 }}
              transition={{ duration: 0.5, delay: i * 0.04 }}
            >
              <Link
                to={`/shipping-to/${city.slug}`}
                data-testid={`city-link-${city.slug}`}
                className="group block rounded-2xl bg-white border border-brand-navy/10 p-5 hover:bg-brand-navy hover:border-brand-navy hover:text-brand-cream transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_15px_30px_-12px_rgba(14,42,86,0.3)]"
              >
                <MapPin size={16} className="text-brand-red mb-3" />
                <div className="font-heading font-black text-base sm:text-lg leading-tight tracking-tight">
                  {city.name}
                </div>
                <div className="text-[11px] font-semibold uppercase tracking-wider opacity-55 mt-1">
                  {city.region}
                </div>
                <div className="mt-3 flex items-center gap-1 text-xs font-bold text-brand-red opacity-0 group-hover:opacity-100 transition-opacity">
                  {lang === "es" ? "Ver detalles" : "See details"}
                  <ArrowRight size={12} />
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CitiesGrid;
